import { Box, Text } from 'grommet';
import { AnimationType } from 'grommet/utils';
import { PropsWithChildren } from 'react';

export type TableHeaderItemProps = PropsWithChildren & {
  width?: string;
  animate?: boolean;
  animation?: AnimationType;
};

export const TableHeaderItem = ({
  width = '20%',
  animate = false,
  animation = { type: 'fadeIn', size: 'large' },
  children,
}: TableHeaderItemProps) => (
  <Box width={width} animation={animate ? animation : undefined}>
    <Text size="xsmall" color="white">
      {children}
    </Text>
  </Box>
);
